module.exports = __webpack_public_path__ + "img/data-item4-2.eb84414.png";